<template>
  <div>
    <div v-if="selectedElement" class="text-left mt-1 ml-1 mr-1 p-1">
      <component
        v-if="showType == 'basic'"
        :is="
          getElementComponentData(
            selectedElement.elType,
            selectedElement.version
          )
        "
        :properties="selectedElement.properties"
        :formId="formId"
        showType="properties"
        @update-properties="updateProperties"
      />
      <b-form-group
        v-if="showType == 'advanced'"
        class="mt-2"
        label="Json Properties"
      >
        <form-builder-code-editor v-model="selectedElementJson" />
      </b-form-group>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import { getElementComponentData } from "../../helpers/formBuilder";
import FormBuilderCodeEditor from "./FormBuilderCodeEditor";
export default {
  name: "FormBuilderElementProperties",
  components: { FormBuilderCodeEditor },
  props: ["formId", "showType"],
  data() {
    return {};
  },
  methods: {
    ...mapMutations("formBuilder", ["setFormBuilderSelectedElement"]),
    getElementComponentData(elementType, elementVersion) {
      return getElementComponentData(elementType, elementVersion).componentName;
    },
    updateProperties(newProperties) {
      const newSelectedElement = { ...this.selectedElement };
      newSelectedElement.properties = newProperties;
      this.setFormBuilderSelectedElement({
        newSelectedElement: newSelectedElement,
        formId: this.formId
      });
    }
  },
  computed: {
    ...mapGetters("formBuilder", {
      selectedElementFB: "formBuilderSelectedElement"
    }),
    ...mapState("formBuilder", {
      forms: state => state.form
    }),
    selectedElement() {
      return this.selectedElementFB({ formId: this.formId });
    },
    selectedElementJson: {
      get() {
        return JSON.stringify(this.selectedElement, undefined, 4);
      },
      set(newValue) {
        this.setFormBuilderSelectedElement({
          newSelectedElement: JSON.parse(newValue),
          formId: this.formId
        });
      }
    }
  }
};
</script>
